import script from "./PromotionB.vue?vue&type=script&setup=true&lang=js"
export * from "./PromotionB.vue?vue&type=script&setup=true&lang=js"

import "./PromotionB.vue?vue&type=style&index=0&id=ab7058b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab7058b0"]])

export default __exports__